import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, createContext } from "react";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RendererContext = createContext(() => {
    throw new Error("Not implemented yet.");
});
export function useRenderer() {
    return useContext(RendererContext);
}
// eslint-disable-next-line react/function-component-definition -- Existing pattern
export function RendererProvider({ renderer, children }) {
    return (_jsx(RendererContext.Provider, { value: renderer, children: children }));
}
//# sourceMappingURL=renderer-context.js.map